export default {
  path: '/review',
  name: 'review',
  meta: { title: '审核智能体' },
  children: [
    {
      path: '/reviewAgent/:type',
      name: 'reviewAgentIndex',
      component: () => import('@/views/reviewAgent/index.vue'),
      meta: { title: '审核智能体', subTitle: '多维度合规校验的智能审核系统', key: 'reviewAgent' },
    },
  ],
};
